import React from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';

import { Form } from '~/components/form';
import Button from '~/components/button';
import {
  createPaymentMethodElements,
  handleValidation,
  parseStripeTokenError,
} from '~/features/stripe';
import { useFlashMessage } from '~/features/flash-messages/flash-message-actions';

import styles from '~/components/account/settings/account-settings.module.scss';

const AddCreditCardForm = ({ onSubmit, user, buttonText = 'Save' }) => {
  // Get a reference to Stripe or Elements using hooks.
  const stripe = useStripe();
  const elements = useElements();
  const { showFlashMessage } = useFlashMessage();

  const userName = user?.firstName && `${user?.firstName} ${user?.lastName}`;

  const handleSubmit = async () => {
    if (elements === null) {
      return;
    }

    await handleValidation(elements, showFlashMessage);

    const res = await createPaymentMethodElements(stripe, elements, {
      billing_details: {
        address: {
          country: 'US',
        },
        name: userName,
      },
    });

    if (res.error) {
      return parseStripeTokenError(res.error);
    } else {
      return onSubmit(res.paymentMethod.id);
    }
  };

  return (
    <Form onSubmit={handleSubmit} resetOnSubmit>
      {({ isSubmitting }) => (
        <div data-testid="stripe-payment-element-wrapper">
          <PaymentElement
            options={{
              layout: { type: 'tabs' },
              defaultValues: {
                billingDetails: {
                  email: user?.email,
                },
              },
              fields: {
                billingDetails: {
                  address: {
                    country: 'never',
                  },
                },
              },
            }}
          />
          <Button
            className={styles.creditCardSubmitButton}
            type="submit"
            isLoading={isSubmitting}
            fullWidth
          >
            <img
              className={styles.lockIcon}
              src="/icons/lock-icon-white.svg"
              alt="closed lock"
            />
            {buttonText}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default AddCreditCardForm;
